import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.cardBackground()};
  border: solid 1px ${({ theme }) => theme.colors.textQuote(0.1)};
  box-shadow: 0 2px 4px 0 ${({ theme }) => theme.colors.textQuote(0.2)};
  border-radius: ${({ theme }) => theme.borders.cardRadius};
  color: ${({ theme }) => theme.colors.textQuote()};
  padding: 10px 20px;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;

  svg {
    fill: ${props => props.theme.colors.textQuote()};
    margin-right: 10px;
    width: 25px;
    height: 25px;
  }
`;
